/**
 * ตรวจสอบสิทธิ์การเข้าถึงเมนูจัดการข้อมูลแพทย์และนักศึกษาฝึกงาน
 * เงื่อนไขตามคำสั่งผู้ใช้งาน:
 * "การจัดการทั้งหมดให้ user งานคอมและ งานวิจัยถ่ายทอดเห็นเท่านั้น คนอื่นซ่อนให้ดูแค่ dash board"
 */
export const checkTraineeManagePermission = () => {
  try {
    // รองรับการทดสอบสลับมุมมองผ่าน query param (เช่น ?preview_role=viewer หรือ ?preview_role=manager)
    if (typeof window !== "undefined" && window.location) {
      const params = new URLSearchParams(window.location.search);
      if (params.get("preview_role") === "manager") return true;
      if (params.get("preview_role") === "viewer") return false;
    }

    const raw = localStorage.getItem("currentUser");
    if (!raw) return false;
    const currentUser = JSON.parse(raw);

    // 1. Super Admin หรือผู้ดูแลระบบส่วนกลาง
    const userName = (currentUser.userName || currentUser.username || "").toLowerCase();
    if (
      userName === "madarakung" ||
      currentUser.role === "Admin" ||
      currentUser.role === "admin" ||
      currentUser.isAdmin === true
    ) {
      return true;
    }

    // 2. ตรวจสอบกลุ่มงานใน userDepartment
    const userDepts = Array.isArray(currentUser.userDepartment) ? currentUser.userDepartment : [];

    const isAuthorized = userDepts.some((dept) => {
      // ตรวจสอบ DepartmentKey:
      // 108 = กลุ่มงานเทคโนโลยีสารสนเทศ (งานคอม)
      // 140 = งานสารสนเทศ/Admin
      const deptKey = dept.departmentKey || dept.DepartmentKey;
      if (deptKey === 108 || deptKey === 140) {
        return true;
      }

      // ตรวจสอบชื่อกลุ่มงาน (ภาษาไทย)
      const deptName = (
        dept.departmentName ||
        dept.DepartmentName ||
        dept.department?.name ||
        dept.name ||
        dept.groupWorkName ||
        ""
      ).toLowerCase();

      // 1. งานคอมพิวเตอร์ / เทคโนโลยีสารสนเทศ
      const isComputer =
        deptName.includes("คอม") ||
        deptName.includes("สารสนเทศ") ||
        deptName.includes("it") ||
        deptName.includes("computer") ||
        deptName.includes("ดิจิทัล");

      // 2. งานวิจัยและถ่ายทอดเทคโนโลยี
      const isResearchTransfer =
        deptName.includes("วิจัย") ||
        deptName.includes("ถ่ายทอด");

      return isComputer || isResearchTransfer;
    });

    if (isAuthorized) return true;

    // 3. ตรวจสอบชื่อแผนก/กลุ่มงานที่ระดับบนสุดของ User
    const topDept = (currentUser.departmentName || currentUser.department || "").toLowerCase();
    if (
      topDept.includes("คอม") ||
      topDept.includes("สารสนเทศ") ||
      topDept.includes("วิจัย") ||
      topDept.includes("ถ่ายทอด")
    ) {
      return true;
    }

    return false;
  } catch (err) {
    console.error("Error checking trainee manage permission:", err);
    return false;
  }
};

